export default __webpack_public_path__ + "static/media/logo-white.a71391d8.png";